export default "__VITE_ASSET__DmmnHrp5__"